<template>
  <nav class="navbar py-0 navbar-expand-lg navbar-light bg-uvu">
    
    <div class="container-fluid bg-uvu">
      <div class="navbar-brand text-white d-flex justify-content-between align-items-center text-uppercase">
          <img src="@/assets/images/UVUMonogramWhite-0007.png"  class="d-none d-sm-block p-1" style="opacity:0.90;" alt="" height="50" />
          <span class="h5 mb-0">{{sessionStore.app_title}}</span>

        <button class="navbar-toggler btn-sm" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="nav col-12 col-lg-auto me-lg-auto mb-2 ms-4 justify-content-end align-items-center mb-md-0">
          <!-- WCAG 2.1.1: use router-link so anchor has a real href and is keyboard accessible -->
          <li><router-link to="/" class="nav-link text-white">Home</router-link></li>
          <li><router-link to="/admin/applications" class="nav-link text-white" v-if="sessionStore.isAdmin">Applications</router-link></li>

          <!-- WCAG 2.1.1: dropdown items use router-link for real href + keyboard access -->
          <li class="nav-item dropdown" v-if="sessionStore.isAdmin">
            <button class="btn btn-transparent text-white dropdown-toggle" type="button" id="auditDropdownButton" data-bs-toggle="dropdown" aria-expanded="false">
              Audit
            </button>
            <ul class="dropdown-menu m-auto" aria-labelledby="auditDropdownButton">
              <li>
                <router-link class="dropdown-item" to="/admin/audit/add-drop">Add/Drop</router-link>
              </li>
            </ul>
          </li>

          <li class="nav-item dropdown" v-if="sessionStore.isAdmin">
            <button class="btn btn-transparent text-white dropdown-toggle" type="button" id="configureDropdownButton" data-bs-toggle="dropdown" aria-expanded="false">
              <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 256 256"><path fill="currentColor" d="M128 82a46 46 0 1 0 46 46a46.06 46.06 0 0 0-46-46Zm0 80a34 34 0 1 1 34-34a34 34 0 0 1-34 34Zm86-31.16c.06-1.89.06-3.79 0-5.68L229.33 106a6 6 0 0 0 1.11-5.29a105.34 105.34 0 0 0-10.68-25.81a6 6 0 0 0-4.53-3l-24.45-2.71q-1.93-2.07-4-4l-2.72-24.46a6 6 0 0 0-3-4.53a105.65 105.65 0 0 0-25.77-10.66a6 6 0 0 0-5.29 1.14l-19.2 15.37a89.64 89.64 0 0 0-5.68 0L106 26.67a6 6 0 0 0-5.29-1.11A105.34 105.34 0 0 0 74.9 36.24a6 6 0 0 0-3 4.53l-2.67 24.45q-2.07 1.94-4 4L40.76 72a6 6 0 0 0-4.53 3a105.65 105.65 0 0 0-10.66 25.77a6 6 0 0 0 1.11 5.23l15.37 19.2a89.64 89.64 0 0 0 0 5.68l-15.38 19.17a6 6 0 0 0-1.11 5.29a105.34 105.34 0 0 0 10.68 25.76a6 6 0 0 0 4.53 3l24.45 2.71q1.94 2.07 4 4L72 215.24a6 6 0 0 0 3 4.53a105.65 105.65 0 0 0 25.77 10.66a6 6 0 0 0 5.29-1.11l19.1-15.32c1.89.06 3.79.06 5.68 0l19.21 15.38a6 6 0 0 0 3.75 1.31a6.2 6.2 0 0 0 1.54-.2a105.34 105.34 0 0 0 25.76-10.68a6 6 0 0 0 3-4.53l2.71-24.45q2.07-1.93 4-4l24.46-2.72a6 6 0 0 0 4.53-3a105.49 105.49 0 0 0 10.66-25.77a6 6 0 0 0-1.11-5.29Zm-3.1 41.63l-23.64 2.63a6 6 0 0 0-3.82 2a75.14 75.14 0 0 1-6.31 6.31a6 6 0 0 0-2 3.82l-2.63 23.63a94.28 94.28 0 0 1-17.36 7.14l-18.57-14.86a6 6 0 0 0-3.75-1.31h-.36a78.07 78.07 0 0 1-8.92 0a6 6 0 0 0-4.11 1.3L100.87 218a94.13 94.13 0 0 1-17.34-7.17l-2.63-23.62a6 6 0 0 0-2-3.82a75.14 75.14 0 0 1-6.31-6.31a6 6 0 0 0-3.82-2l-23.63-2.63A94.28 94.28 0 0 1 38 155.14l14.86-18.57a6 6 0 0 0 1.3-4.11a78.07 78.07 0 0 1 0-8.92a6 6 0 0 0-1.3-4.11L38 100.87a94.13 94.13 0 0 1 7.17-17.34l23.62-2.63a6 6 0 0 0 3.82-2a75.14 75.14 0 0 1 6.31-6.31a6 6 0 0 0 2-3.82l2.63-23.63A94.28 94.28 0 0 1 100.86 38l18.57 14.86a6 6 0 0 0 4.11 1.3a78.07 78.07 0 0 1 8.92 0a6 6 0 0 0 4.11-1.3L155.13 38a94.13 94.13 0 0 1 17.34 7.17l2.63 23.64a6 6 0 0 0 2 3.82a75.14 75.14 0 0 1 6.31 6.31a6 6 0 0 0 3.82 2l23.63 2.63a94.28 94.28 0 0 1 7.14 17.29l-14.86 18.57a6 6 0 0 0-1.3 4.11a78.07 78.07 0 0 1 0 8.92a6 6 0 0 0 1.3 4.11L218 155.13a94.13 94.13 0 0 1-7.15 17.34Z"/></svg>
              Configure
            </button>
            <ul class="dropdown-menu m-auto" aria-labelledby="configureDropdownButton">
              <li><router-link class="dropdown-item" to="/admin/configure/agreements">Agreements Configuration</router-link></li>
              <li><router-link class="dropdown-item" to="/admin/configure/benefits">Benefit/Types Configuration</router-link></li>
              <li><router-link class="dropdown-item" to="/admin/configure/documents">Document/Types Configuration</router-link></li>
              <li><router-link class="dropdown-item" to="/admin/configure/email-content">Email Content</router-link></li>
              <li><router-link class="dropdown-item" to="/admin/configure/general-questions">General Questions</router-link></li>
              <li><router-link class="dropdown-item" to="/admin/configure/infotext">Infotext</router-link></li>
              <li><router-link class="dropdown-item" to="/admin/configure/requirements">Requirements Criteria</router-link></li>
              <li><router-link class="dropdown-item" to="/admin/configure/service-types">Service/Types Configuration</router-link></li>
              <li><router-link class="dropdown-item" to="/admin/configure/statuses">Status/Types Configuration</router-link></li>
              <li><router-link class="dropdown-item" to="/admin/configure/assignment-staff">Ownership Configuration</router-link></li>
            </ul>
          </li>

        </ul>

        <div class="d-flex justify-content-end align-items-center">

          <span class="navbar-text d-flex justify-content-center align-items-center d-none d-lg-block">
            <!-- WCAG 1.4.3: env badge uses white text on dark background instead of yellow on green -->
            <span class="badge bg-dark text-white fw-bold pe-2 me-2" v-if="sessionStore.environment && sessionStore.environment !== 'prod'">[{{sessionStore.environment}}]</span>
            <!-- WCAG 1.1.1: decorative icon hidden from AT; name announced via adjacent text -->
            <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" class="text-white" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path d="M24 0v24H0V0h24ZM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018Zm.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01l-.184-.092Z"/><path fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2ZM8.5 9.5a3.5 3.5 0 1 1 7 0a3.5 3.5 0 0 1-7 0Zm9.758 7.484A7.985 7.985 0 0 1 12 20a7.985 7.985 0 0 1-6.258-3.016C7.363 15.821 9.575 15 12 15s4.637.821 6.258 1.984Z"/></g></svg>
            <span class='text-white pe-1 mx-2 fs-6' v-on:click.prevent="copy_to_clipboard(sessionStore.accessToken)">{{sessionStore.DisplayName}}</span>
          </span>
        </div>
      </div>

    </div>


  </nav>

</template>

<script>

import { useSessionStore } from './../stores/SessionStore'

import { defineComponent } from 'vue';

export default defineComponent({
setup() {
  const sessionStore = useSessionStore()

  return {  sessionStore}
},
data() {
  return {
  }
},
async mounted(){
},
name: 'application-header',
props: [],
methods : {
    copy_to_clipboard(text){
        navigator.clipboard.writeText(text)
    }
}
});

</script>


<style scoped lang="scss">

.navbar-toggler-icon{
font-size: 0.5em;
}

.nav-link{
cursor: pointer;
}

/* WCAG 2.4.7: visible focus for all interactive elements in the header */
a:focus-visible,
button:focus-visible,
.nav-link:focus-visible,
.dropdown-item:focus-visible {
  outline: 3px solid #fff;
  outline-offset: 2px;
}

</style>